export const SAGA_OPEN_TOAST = 'SAGA_OPEN_TOAST';
export const SAGA_POST_LOGIN = 'SAGA_POST_LOGIN';
export const SAGA_POST_LOGOUT = 'SAGA_POST_LOGOUT';
export const SAGA_GET_PLAYER_SETTINGS = 'SAGA_GET_PLAYER_SETTINGS';
export const SAGA_GET_CHAPTER_LIST = 'SAGA_GET_CHAPTER_LIST';
export const SAGA_PUT_PLAYER = 'SAGA_PUT_PLAYER';
